import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const CustomerInfoSection = ({ formData, errors, onChange }) => {
  return (
    <div className="bg-card rounded-lg border border-border elevation-1 overflow-hidden">
      <div className="p-6 border-b border-border bg-muted/30">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="User" size={20} />
          Customer Information
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Enter the customer's contact details
        </p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="First Name"
            type="text"
            name="customerFirstName"
            value={formData?.customerFirstName}
            onChange={onChange}
            placeholder="John"
            error={errors?.customerFirstName}
            required
          />
          <Input
            label="Last Name"
            type="text"
            name="customerLastName"
            value={formData?.customerLastName}
            onChange={onChange}
            placeholder="Doe"
            error={errors?.customerLastName}
            required
          />
          <Input
            label="Email Address"
            type="email"
            name="customerEmail"
            value={formData?.customerEmail}
            onChange={onChange}
            placeholder="john.doe@example.com"
            error={errors?.customerEmail}
            required
          />
          <Input
            label="Phone Number"
            type="tel"
            name="customerPhone"
            value={formData?.customerPhone}
            onChange={onChange}
            placeholder="(808) 555-1234"
            error={errors?.customerPhone}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoSection;